/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";

export function useTimeoutHover() {
  const timerRef = React.useRef(-1);

  const setTimeoutHoverAction = (action: () => void, timeout: number) => {
    window.clearTimeout(timerRef.current);

    const timer = window.setTimeout(() => {
      action !== undefined && action();
    }, timeout);

    timerRef.current = timer;
  };

  const clearTimeoutHover = () => window.clearTimeout(timerRef.current);

  React.useEffect(() => {
    return () => {
      window.clearTimeout(timerRef.current);
    };
  }, []);

  return {
    setTimeoutHoverAction,
    clearTimeoutHover,
  };
}
